export default getText => key =>
  ({
    title: getText('Main problem areas', 'Patient_Sidebar'),
    selectedArea: getText('Selected Area', 'Patient_Sidebar'),
    pageIndicator: getText('{current} of {total} areas', 'Patient_Sidebar'),
  }[key])
